import { ScgpExportOrderStatus } from "@saleor/graphql";

interface orderStatusType {
  color: string;
  status: ScgpExportOrderStatus;
  name: string;
}

export const orderStatusOptions: orderStatusType[] = [
  {
    color: "#A3AED0",
    status: ScgpExportOrderStatus.RECEIVED_ORDER,
    name: "Received Order"
  },
  {
    color: "#FFC107",
    status: ScgpExportOrderStatus.CREDIT_CASH_ISSUE,
    name: "Credit/Cash Issue"
  },
  {
    color: "#3860BE",
    status: ScgpExportOrderStatus.PARTIAL_COMMITTED_ORDER,
    name: "Partial Committed Order"
  },
  {
    color: "#007BFF",
    status: ScgpExportOrderStatus.READY_FOR_DELIVERY,
    name: "Ready For Delivery"
  },
  {
    color: "#009FB8",
    status: ScgpExportOrderStatus.PARTIAL_DELIVERY,
    name: "Partial Delivery"
  },
  {
    color: "#6CC04A",
    status: ScgpExportOrderStatus.COMPLETED_DELIVERY,
    name: "Completed Delivery"
  },
  {
    color: "#E41B17",
    status: ScgpExportOrderStatus.CANCELLED,
    name: "Cancelled"
  },
  {
    color: "#1E7D34",
    status: ScgpExportOrderStatus.COMPLETED_ORDER,
    name: "Completed Order"
  },
  {
    color: "#AF52DE",
    status: ScgpExportOrderStatus.FULL_COMMITTED_ORDER,
    name: "Full Committed Order"
  }
];

export enum StatusFilter {
  INFO = "INFO",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR"
}
